import React from 'react';
import { connect } from 'react-redux';

import { EditorialEventRenderer } from './EditorialEventRenderer';
import { PersonalEventRenderer } from './PersonalEventRenderer';

import {
    COLLECTION_PAGE_GA_CATEGORY,
    EDITORIAL_COLLECTION_PAGE_GA_CATEGORY,
} from '../../constants';

import './EventContainer.scss';

const EventContainerRenderer = (props) => {
    const Renderer = props.isQuality
        ? EditorialEventRenderer
        : PersonalEventRenderer;

    return <Renderer {...props} />;
};

const _mapStateToProps = (state) => ({
    collectionId: state.collection.id,
    isEditMode: state.ui.isEditMode,
    currencyFormat: state.currencyFormat,
    isQuality: state.collection.isQuality,
    isAuthenticated: state.isAuthenticated,
    events: state.events,
    gaCategory: state.collection.isQuality
        ? EDITORIAL_COLLECTION_PAGE_GA_CATEGORY
        : COLLECTION_PAGE_GA_CATEGORY,
    userId: state.userId,
    affCode: state.collection.isInfluencer
        ? 'ebdssbinfluencercollection'
        : state.collection.isQuality
        ? 'ebdssbeditorialcollection'
        : 'ebcollection',
});

export const EventContainer = connect(_mapStateToProps)(EventContainerRenderer);
